export default "__VITE_ASSET__37428cd8__"